










































import { cloneDeep } from "lodash";
import { Component, Vue } from 'vue-property-decorator';

import Icon from "../../../../components/Icon/Icon.vue";
import { errorNotificationWrapper } from "../../../../logic/helpers/NotificationService";
import FeedbackApi from "../../Api/Feedback.api";
import { ConfigMenuItem } from "../../includes/types/MenuItem";
import { SendFeedbackData, SendFeedbackTypeEnum } from "../../types/SendFeedback.types";
import FeedbackExtraItems from "./FeedbackExtraItems.vue";
import FeedbackForm from "./FeedbackForm.vue";

@Component({
  components: {
    FeedbackExtraItems,
    Icon,
    FeedbackForm
  }
})
export default class FeedbackContainer extends Vue {
  isFeedbackFormModalOpen = false

  form: SendFeedbackData = this.defaultModel()

  isFormSending = false

  get feedbackItems(): Array<Record<'menuItem', ConfigMenuItem>> {
    return this.$store.state.AdminTemplate.applicationConfig.feedbackItems ?? []
  }

  get isSubmitDisabled() {
    const textLen = this.form.text.trim().length

    if (this.form.type === SendFeedbackTypeEnum.Feedback) {
      return !textLen || this.form.rating === 0
    } else if (this.form.type === SendFeedbackTypeEnum.Error) {
      return !textLen
    } else {
      return true
    }
  }

  defaultModel(): SendFeedbackData {
    return cloneDeep({
      type: SendFeedbackTypeEnum.Error,
      text: '',
      file: null
    })
  }

  fillFormData(model: SendFeedbackData) {
    const fd = new FormData()

    Object.keys(model).forEach((key) => {
      fd.append(key, model[key as keyof SendFeedbackData]);
    })

    return fd
  }

  submitForm() {
    const fd = this.fillFormData(this.form)

    this.isFormSending = true

    FeedbackApi.sendFeedback(fd)
      .then(() => {
        this.isFeedbackFormModalOpen = false

        this.form = this.defaultModel()
      })
      .catch(e => errorNotificationWrapper(this.$t('error').toString(), e))
      .finally(() => this.isFormSending = false)
  }
}
